module.exports = __webpack_public_path__ + "img/gl.76e26e9b.svg";